import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';

import { Row, Col, Card, CardBody, Table, Button, Input, Spinner, Alert } from 'reactstrap';

import { connect } from 'react-redux';

import {
  getSubscriptionTooltips,
  updateSubscriptionTooltip,
} from '../../../../../actions/contentManagement';

class SubscriptionTooltips extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    dashboardTooltips: PropTypes.shape(),
    fetchTooltips: PropTypes.func.isRequired,
    updateTooltip: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    dashboardTooltips: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      success: null,
      tooltips: {},
      subTabs: [],
      subscriptionSubTab: {},
    };
  }

  componentDidMount() {
    const { fetchTooltips, admin, user, isLoggedIn, history } = this.props;

    fetchTooltips().then((res) => {
      console.log('fetchTooltips', { res });
      if (res && res.tooltips) {
        let tooltips = {};
        let subTabs = [{ id: "subscription", name: "subscription" }];
        let subscriptionSubTab = {};

        Object.keys(res.tooltips).map((key) => {
          if (res.tooltips[key].subTab && res.tooltips[key].subTab === 'subscription') {
            subscriptionSubTab[key] = res.tooltips[key];
          } else {
            tooltips[key] = res.tooltips[key];
          }
          return null;
        });
        this.setState({ tooltips, subTabs, subscriptionSubTab });
      }
    });
  }

  openSubtab = (id) => {
    this.setState({ openedTab: id });
  }

  handleChange = (e, type) => {
    e.preventDefault();

    console.log('target', { target: e.target });
    if (e.target) {
      const { name, value } = e.target;
      console.log(e.target.name);

      if (type === 'subscription') {
        this.setState((prevState) => ({
          subscriptionSubTab: {
            ...prevState.subscriptionSubTab,
            [name]: {
              ...prevState.subscriptionSubTab[name],
              value,
            },
          },
          error: null,
          success: null,
        }));
      } else {
        this.setState((prevState) => ({
          tooltips: {
            ...prevState.tooltips,
            [name]: {
              ...prevState.tooltips[name],
              value,
            },
          },
          error: null,
          success: null,
        }));
      }
    }
  };

  updateTooltips = () => {
    const { updateTooltips, user } = this.props;
    const { tooltips, subscriptionSubTab } = this.state;

    let adminName;

    if (user.name || (user.firstName && user.lastName)) {
      adminName = user.name ? user.name : `${user.firstName} ${user.lastName}`;
    }

    this.setState({ saveSpinner: true });

    updateTooltips({ ...subscriptionSubTab, ...tooltips }, adminName).then((res) => {
      if (res === 'success') {
        this.setState({ success: true, error: null, saveSpinner: null });
      } else if (res === 'error') {
        this.setState({ success: null, error: true, saveSpinner: null });
      }
    });
  }

  render() {
    const { user } = this.props;
    const {
      error,
      success,
      name,
      tooltips,
      subTabs,
      subscriptionSubTab,
      openedTab,
      saveSpinner,
    } = this.state;

    console.log('SubscriptionSubTab', tooltips, subTabs, subscriptionSubTab);

    return (
      <div>
        {(!!success) && <Alert color="success">Update successful</Alert>}
        {(!!error) && <Alert color="danger">Update failed, please try again</Alert>}
        {tooltips ? Object.keys(tooltips).sort((a, b) => (tooltips[a].index - tooltips[b].index)).map((key) => (
          <Row>
            <Col sm="6">
              {tooltips[key].name}
            </Col>
            <Col sm="6">
              <Input
                type="textarea"
                name={key}
                id={`data-${key}`}
                value={tooltips[key].value}
                onChange={(e) => this.handleChange(e, null)}
              />
            </Col>
          </Row>
        )) : (null)}

        <Button onClick={this.updateTooltips}>
          Save
          {saveSpinner ? (
            <Spinner animation="border" variant="primary" style={{ width: '1.3rem', height: '1.3rem' }}> {''} </Spinner>
          ) : (null)}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  subscriptionTooltips: state.contentManagement.subscriptionTooltips || {},
});

const mapDispatchToProps = {
  fetchTooltips: getSubscriptionTooltips,
  updateTooltips: updateSubscriptionTooltip,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SubscriptionTooltips));
